import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, TextField, Select, MenuItem, Tabs, Tab, Switch, FormControlLabel } from '@mui/material';

export default function ContestsPage() {
  const [contests, setContests] = useState([]);
  const [tab, setTab] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({
    title: '', contest_type: 'quiz', description: '',
    start_date: '', end_date: '', prize_eur: 0, prize_description: '',
    winners_count: 1, multiplier: 1.0, status: 'draft',
    visible_in_miniapp: true, notify_users: true
  });
  const tok = localStorage.getItem('dashboard_token');

  const load = () => {
    fetch('/api/contests?status='+tab, { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setContests(d || []));
  };
  useEffect(() => { load(); }, [tab]);

  const save = async () => {
    if(!form.title || !form.start_date || !form.end_date){
      setMsg('❌ Заповніть назву і дати'); setTimeout(()=>setMsg(''),3000); return;
    }
    const url = editing ? '/api/contests/'+editing : '/api/contests';
    const method = editing ? 'PUT' : 'POST';
    // Конвертуємо локальний час в UTC ISO
    const formUtc = {...form};
    if (form.start_date) formUtc.start_date = new Date(form.start_date).toISOString();
    if (form.end_date) formUtc.end_date = new Date(form.end_date).toISOString();
    const r = await fetch(url, {
      method, headers:{ Authorization:'Bearer '+tok, 'Content-Type':'application/json' },
      body: JSON.stringify(formUtc)
    });
    if(r.ok){
      setMsg('✅ Збережено'); setTimeout(()=>setMsg(''),2000);
      setShowForm(false); setEditing(null); load();
      setForm({ title: '', contest_type: 'quiz', description: '', start_date: '', end_date: '', prize_eur: 0, prize_description: '', winners_count: 1, multiplier: 1.0, status: 'draft', visible_in_miniapp: true, notify_users: true });
    }
  };

  const del = async (id) => {
    if(!window.confirm('Видалити конкурс?')) return;
    await fetch('/api/contests/'+id, { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    setMsg('🗑 Видалено'); setTimeout(()=>setMsg(''),2000); load();
  };

  const finalize = async (id) => {
    if(!window.confirm('Завершити конкурс і визначити переможців?')) return;
    await fetch('/api/contests/'+id+'/finalize', { method:'POST', headers:{ Authorization:'Bearer '+tok } });
    setMsg('🏆 Завершено'); setTimeout(()=>setMsg(''),2000); load();
  };

  const edit = (c) => {
    setEditing(c.id);
    const localISO = (utc) => {
      if (!utc) return '';
      const d = new Date(utc);
      const off = d.getTimezoneOffset();
      const local = new Date(d.getTime() - off * 60000);
      return local.toISOString().slice(0, 16);
    };
    setForm({...c, start_date: localISO(c.start_date), end_date: localISO(c.end_date)});
    setShowForm(true);
  };

  const types = {
    quiz: '❓ Вікторина', race: '🏃 Гонка рефералів', raffle: '🎲 Розіграш',
    cashback: '💰 Кешбек', double_bonus: '🎁 Подвійні бонуси',
    flash: '⚡ Флеш-акція', seasonal: '🎄 Сезонна', wild_week: '🔥 Шалений Тиждень'
  };

  const statusColors = {
    draft: '#888', active: '#4caf50', finished: '#2196f3', paused: '#ff9800'
  };

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>🎰 Конкурси / Акції / Вікторини</Typography>

      <Box sx={{display:'flex',gap:2,mb:2,alignItems:'center'}}>
        <Button variant="contained" onClick={()=>{setShowForm(!showForm); setEditing(null);}} sx={{bgcolor:'#FFD700',color:'#000'}}>
          {showForm ? '✖ Закрити' : '➕ Створити новий'}
        </Button>
        {msg && <Typography sx={{color:'#4caf50'}}>{msg}</Typography>}
      </Box>

      <Tabs value={tab} onChange={(e,v)=>setTab(v)} sx={{mb:2,'& .MuiTab-root':{color:'#aaa'},'& .Mui-selected':{color:'#FFD700'}}}>
        <Tab value="all" label="📋 Всі"/>
        <Tab value="active" label="🟢 Активні"/>
        <Tab value="draft" label="📝 Чернетки"/>
        <Tab value="finished" label="🏆 Завершені"/>
      </Tabs>

      {showForm && (
        <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #FFD700',p:3,mb:3}}>
          <Typography variant="h6" sx={{color:'#FFD700',mb:2}}>{editing ? '✏️ Редагувати' : '➕ Новий конкурс'}</Typography>
          <Box sx={{display:'flex',flexDirection:'column',gap:2}}>
            <TextField label="Назва" value={form.title} onChange={e=>setForm({...form,title:e.target.value})}
              fullWidth size="small" sx={{'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
            <Select value={form.contest_type} onChange={e=>setForm({...form,contest_type:e.target.value})}
              size="small" MenuProps={{PaperProps:{sx:{bgcolor:'#fff'}}}} sx={{color:'#fff','& .MuiSelect-icon':{color:'#fff'}}}>
              {Object.entries(types).map(([k,v])=><MenuItem key={k} value={k} sx={{color:"#000",bgcolor:"#fff","&:hover":{bgcolor:"#FFD700"}}}>{v}</MenuItem>)}
            </Select>
            <TextField label="Опис" value={form.description} onChange={e=>setForm({...form,description:e.target.value})}
              multiline rows={2} fullWidth size="small" sx={{'& textarea':{color:'#fff'},'& label':{color:'#aaa'}}}/>
            <Box sx={{display:'flex',gap:2,flexWrap:'wrap'}}>
              <TextField label="Старт" type="datetime-local" value={form.start_date} onChange={e=>setForm({...form,start_date:e.target.value})}
                size="small" InputLabelProps={{shrink:true}} sx={{flex:1,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
              <TextField label="Завершення" type="datetime-local" value={form.end_date} onChange={e=>setForm({...form,end_date:e.target.value})}
                size="small" InputLabelProps={{shrink:true}} sx={{flex:1,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
            </Box>
            <Box sx={{display:'flex',gap:2,flexWrap:'wrap'}}>
              <TextField label="Призовий фонд (€)" type="number" value={form.prize_eur} onChange={e=>setForm({...form,prize_eur:e.target.value})}
                size="small" sx={{flex:1,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
              <TextField label="К-сть переможців" type="number" value={form.winners_count} onChange={e=>setForm({...form,winners_count:e.target.value})}
                size="small" sx={{flex:1,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
              <TextField label="Множник" type="number" value={form.multiplier} onChange={e=>setForm({...form,multiplier:e.target.value})}
                size="small" sx={{flex:1,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
            </Box>
            <TextField label="Опис призу" value={form.prize_description} onChange={e=>setForm({...form,prize_description:e.target.value})}
              fullWidth size="small" sx={{'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
            <Box sx={{display:'flex',gap:2,flexWrap:'wrap'}}>
              <FormControlLabel control={<Switch checked={form.visible_in_miniapp} onChange={e=>setForm({...form,visible_in_miniapp:e.target.checked})}/>}
                label={<Typography sx={{color:'#fff',fontSize:13}}>Показати в Mini App</Typography>}/>
              <FormControlLabel control={<Switch checked={form.notify_users} onChange={e=>setForm({...form,notify_users:e.target.checked})}/>}
                label={<Typography sx={{color:'#fff',fontSize:13}}>Сповістити юзерів</Typography>}/>
            </Box>
            <Select value={form.status} onChange={e=>setForm({...form,status:e.target.value})}
              size="small" MenuProps={{PaperProps:{sx:{bgcolor:'#fff'}}}} sx={{color:'#fff','& .MuiSelect-icon':{color:'#fff'}}}>
              <MenuItem value="draft" sx={{color:"#000",bgcolor:"#fff","&:hover":{bgcolor:"#FFD700"}}}>📝 Чернетка</MenuItem>
              <MenuItem value="active" sx={{color:"#000",bgcolor:"#fff","&:hover":{bgcolor:"#FFD700"}}}>🟢 Активний</MenuItem>
              <MenuItem value="paused" sx={{color:"#000",bgcolor:"#fff","&:hover":{bgcolor:"#FFD700"}}}>⏸ На паузі</MenuItem>
            </Select>
            <Button variant="contained" onClick={save} sx={{bgcolor:'#FFD700',color:'#000'}}>💾 Зберегти</Button>
          </Box>
        </Paper>
      )}

      {contests.length === 0 ? (
        <Paper sx={{bgcolor:'#1a1a2e',p:3,textAlign:'center',color:'#aaa'}}>Немає конкурсів</Paper>
      ) : contests.map(c => (
        <Paper key={c.id} sx={{bgcolor:'#1a1a2e',border:'1px solid '+statusColors[c.status],p:2,mb:2}}>
          <Box sx={{display:'flex',justifyContent:'space-between',mb:1,flexWrap:'wrap'}}>
            <Box>
              <Typography sx={{color:statusColors[c.status],fontSize:12,fontWeight:'bold'}}>
                {types[c.contest_type] || c.contest_type} | {c.status?.toUpperCase()}
              </Typography>
              <Typography sx={{color:'#FFD700',fontSize:16,fontWeight:'bold',mt:0.5}}>{c.title || c.name}</Typography>
            </Box>
            <Typography sx={{color:'#FFD700',fontSize:14}}>💰 €{c.prize_eur || 0}</Typography>
          </Box>
          {c.description && <Typography sx={{color:'#aaa',fontSize:13,mb:1}}>{c.description}</Typography>}
          <Typography sx={{color:'#888',fontSize:11}}>📅 {c.start_date?.slice(0,16)} → {c.end_date?.slice(0,16)} | 🏆 {c.winners_count} переможців</Typography>
          <Box sx={{display:'flex',gap:1,mt:1.5,flexWrap:'wrap'}}>
            <Button size="small" onClick={()=>edit(c)} variant="outlined" sx={{borderColor:'#FFD700',color:'#FFD700'}}>✏️</Button>
            {c.status === 'active' && <Button size="small" onClick={()=>finalize(c.id)} variant="outlined" sx={{borderColor:'#4caf50',color:'#4caf50'}}>🏆 Завершити</Button>}
            <Button size="small" onClick={()=>del(c.id)} variant="outlined" sx={{borderColor:'#f44',color:'#f44'}}>🗑</Button>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
